module.exports = __webpack_public_path__ + "static/FuturaPT-Bold-7c7bef4cdb04fba6a9ecca71046ae5fd.woff2";